import { $http } from '@/utils/https';
import { objectToQueryString } from '@/helpers/variables';
import type { Product } from '@/types/shop';

interface State {
  isSalesLoading: boolean;
  sales: Product | null;
}

const state: State = {
  isSalesLoading: false,
  sales: null
};

const getters = {
  isSalesLoading: (state: State) => state.isSalesLoading,
  sales: (state: State) => state.sales
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  GET_PROMOTIONS_PRODUCTS: async ({ commit }: any, params: any) => {
    let url = `v1/sales`;
    if (params && Object.keys(params).length) {
      url = objectToQueryString(url);
    }
    try {
      const response = await $http.get(url);
      return response.data;
    } catch (e) {
      throw e;
    }
  },
  GET_PROMOTION: async ({ commit }: any, promoId: number) => {
    let url = `v1/sales/${promoId}`;
    try {
      const response = await $http.get(url);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  },
  /**
   *
   * @param commit
   * @param params {{ids: [number]}}
   * @constructor
   */
  // eslint-disable-next-line no-unused-vars
  GET_PROMOTIONS_PRODUCTS_FOR_BASKET: async ({ commit }: any, params: any) => {
    let url = `v1/basket/products`;
    try {
      const response = await $http.get(url, { params });
      return response.data;
    } catch (e) {
      throw e;
    }
  },
  CHECK_SALES: async ({ commit }: any, payload: any) => {
    try {
      commit('CHANGE_SALES_LOADING', true);
      const response = await $http.get('v1/products/check-sale', {
        params: payload
      });
      commit('SET_SALES', response.data.data);
      commit('basket/UPDATE_BASKET_PRODUCTS_PRICES', response.data.data, { root: true });
      return response.data.data;
    } catch (e) {
      throw e;
    } finally {
      commit('CHANGE_SALES_LOADING', false);
    }
  }
};

const mutations = {
  CHANGE_SALES_LOADING(state: State, status: boolean) {
    state.isSalesLoading = status;
  },
  SET_SALES(state: State, sales: Product[]) {
    console.log('sales', sales);
    // @ts-ignore
    state.sales = sales;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
